/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// Capture UTM parameters site-wide (any page), so pages further into the
// session that don't have them in the URL can still detect "this session
// arrived via UTM X" — used by sections like utm-test-section.liquid.
// Uses cookies (not sessionStorage) so it's shared across tabs in the
// same browser, matching how Shopify's own session cookies behave.
(function () {
  // Cookies auto-expire after 20 hours so a UTM session can't linger forever.
  var UTM_COOKIE_MAX_AGE = 60 * 60 * 20;

  function setUtmCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + UTM_COOKIE_MAX_AGE;
  }
  function deleteUtmCookie(name) {
    document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
  function getUtmCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function getUtmCookieNames() {
    return document.cookie.split(';')
      .map(function (c) { return c.split('=')[0].trim(); })
      .filter(function (n) { return n.indexOf('utm_seen_') === 0; });
  }

  var params = new URLSearchParams(window.location.search);
  var isHome = window.location.pathname === '/';
  var hasUtm = false;

  params.forEach(function (value, key) {
    if (key.indexOf('utm_') === 0) {
      hasUtm = true;
      setUtmCookie('utm_seen_' + key, value);
    }
  });

  // Only reset when the homepage is reached from OUTSIDE our own site
  // (Google Ads, Google search, any external referrer, or none at all)
  // without the UTM — internal navigation (e.g. clicking our own logo)
  // should not wipe an already-captured session.
  var referrerHost = '';
  try {
    referrerHost = document.referrer ? new URL(document.referrer).hostname : '';
  } catch (e) {}
  var isInternalReferrer = referrerHost === window.location.hostname;

  if (isHome && !hasUtm && !isInternalReferrer) {
    getUtmCookieNames().forEach(deleteUtmCookie);
  }

  // Hide the accent-style announcement bar while a "deal" UTM session
  // (captured above) is active. Which utm_campaign values count as a deal,
  // and whether to hide the bar at all, are both managed from Theme
  // settings → "UTM deal campaign" (see window.theme.utm in theme.liquid) —
  // no code change needed to add/remove a campaign value. Also flags <html>
  // so custom.css can cancel the sticky-header offset that otherwise leaves
  // the bar's space behind on scroll (see .has-scrolled .site-header in
  // custom.css).
  var utmSettings = (window.theme && window.theme.utm) || {};
  var dealValues = (utmSettings.dealValues || '')
    .split(',')
    .map(function (v) { return v.trim(); })
    .filter(Boolean);

  if (utmSettings.hideAnnouncement && dealValues.indexOf(getUtmCookie('utm_seen_utm_campaign')) !== -1) {
    document.documentElement.classList.add('utm-hide-announcement');
    document.querySelectorAll('.announcement-bar-static').forEach(function (bar) {
      if (bar.querySelector('.announcement.subheading-text')) {
        bar.style.display = 'none';
      }
    });
  }
})();


(function() {
  // Add custom code below this line

document.addEventListener("DOMContentLoaded", function () {
  
  const breakpoint = 768;
  const isDesktop = window.innerWidth >= breakpoint;
  const flickityInstances = new WeakMap();
  const accordionItems = document.querySelectorAll(".custom-accordion__item");

  if (!accordionItems.length) return; // No accordion, exit safely

  initializeSlideronPageLoad();

  accordionItems.forEach(item => {
    const header = item.querySelector(".custom-accordion__header");
    if (!header) return;

    const iconPlus = header.querySelector(".custom-icon-plus");
    const iconMinus = header.querySelector(".custom-icon-minus");

    header.addEventListener("click", () => {
      item.classList.toggle("custom-collapsed");

      if(item.classList.contains("custom-collapsed")){
        iconPlus.style.display = "block";
        iconMinus.style.display = "none";
      } else {
        iconPlus.style.display = "none";
        iconMinus.style.display = "block";
      }

      // initiate slider on click
      if (!item.classList.contains('custom-collapsed')) {
          setTimeout(() => {
            //const carousels = item.querySelectorAll('.carousel:not(.carousel--inactive):not(.flickity-enabled)'); // Select all carousel elements
            const carousels = item.querySelectorAll('.carousel:not(.carousel--inactive)'); // Select all carousel elements
           
            if(carousels.length > 0){
              updateCarousels(carousels);
              // carousels.forEach((carousel) => {
              //   const isInsideExcludedWrapper = carousel.closest('.accordion__item--first') !== null;
      
              //   if (!isInsideExcludedWrapper) {
              //     // Destroy existing Flickity instance for this specific carousel (if applicable)
              //     if (carousel.flkty) {
              //       carousel.flkty.destroy();
              //     }
              //     const carousel_items = carousel.querySelectorAll('.carousel__item');
              //     carousel_items.forEach((carousel_item) => {
              //       carousel_item.style.display='block';
              //     });
              //     // Create a new Flickity instance for this specific carousel
              //     updateCarousels(carousel);
                    
              //     console.log('Slider refreshed');
              //   }
              // });
            }
    
          }, 150);
        }
      
    });
  });

  function initFlickity(carousel) {
    if (!flickityInstances.has(carousel)) {
      // Create a new Flickity instance for this specific carousel
      carousel.flkty = new themeVendor.Flickity(carousel, {
        cellSelector: undefined,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        autoPlay: false,
        resize: true,
        cellAlign: "left",
      });
      flickityInstances.set(carousel, carousel.flkty);
    }
  }

  function destroyFlickity(carousel) {
    const instance = flickityInstances.get(carousel);
    if (instance) {
      instance.destroy();
      flickityInstances.delete(carousel);
    }
  }

  function updateCarousels(carousels) {
    const isDesktop = window.innerWidth >= breakpoint;

    carousels.forEach(carousel => {
      if (isDesktop) {
        //console.log('initialize');
        destroyFlickity(carousel)
        initFlickity(carousel);
      } else {
        //console.log('destroy');
        destroyFlickity(carousel);
      }
    });
  }

  // Initial load
  //updateCarousels();
  function initializeSlideronPageLoad(){
    accordionItems.forEach(item => {
      const header = item.querySelector(".custom-accordion__header");
      if (!item.classList.contains('custom-collapsed')) {
        const carousels = item.querySelectorAll('.carousel'); // Select all carousel elements
       
        if(carousels.length > 0){
          updateCarousels(carousels);
        }
      }
    });
  }

  // On resize
  window.addEventListener("resize", function () {
    clearTimeout(window._flickityResizeTimeout);
    accordionItems.forEach(item => {
      const header = item.querySelector(".custom-accordion__header");
      if (!item.classList.contains('custom-collapsed')) {
        const carousels = item.querySelectorAll('.carousel'); // Select all carousel elements
       
        if(carousels.length > 0){
          window._flickityResizeTimeout = setTimeout(updateCarousels(carousels), 150);
        }
      }
    });
    
  });
});




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// 
document.addEventListener("DOMContentLoaded", function () {
  const cartBtn = document.querySelector(".product__submit__buttons");
  if (!cartBtn) return;

  // Placeholder ki height fixed 10px
  const placeholder = document.createElement("div");
  placeholder.style.height = "10px";
  cartBtn.parentNode.insertBefore(placeholder, cartBtn);

  // "Sticky bar only" mode (sections/section-product.liquid, data-sticky-bar-root)
  // relocates its whole section to be a direct child of <body> instead of just
  // the button - some other content earlier on a heavier page can end up
  // painting in front of a plain fixed+high-z-index element no matter how high
  // the z-index goes, in a way that isn't explained by any rule read statically.
  // Moving the ENTIRE section (not just the button) keeps every internal
  // relationship intact - the <form>, its add-to-cart button, and the theme's
  // own [data-product] JSON/init code all stay exactly as nested as before -
  // only the section's position in the overall page changes.
  const stickyBarSection = cartBtn.closest("[data-sticky-bar-root]");
  if (stickyBarSection) {
    // Move Shopify's own auto-generated wrapper (#shopify-section-{id}), not
    // just our inner <section>, so the section stays a complete, correctly
    // nested unit exactly as Shopify's own section registration/init expects
    // to find it - only its position in the page changes, nothing about its
    // own structure does.
    const stickyBarRoot = stickyBarSection.closest(".shopify-section") || stickyBarSection;
    document.body.appendChild(stickyBarRoot);
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  }

  // Whichever element is actually fixed differs by breakpoint (the whole
  // bar on desktop, just the submit button on mobile) - measure that one
  // so the body gets exactly enough bottom space to stop it covering content.
  // The same height also drives --sticky-bar-height, used on mobile to lift
  // the Rewards pill and scroll-to-top button clear of the bar instead of
  // letting them sit on top of it.
  function reserveStickySpace() {
    if (!cartBtn.classList.contains("sticky-cart")) {
      document.body.style.paddingBottom = "";
      document.body.classList.remove("has-sticky-cart");
      document.documentElement.style.removeProperty("--sticky-bar-height");
      return;
    }
    let fixedEl = cartBtn;
    if (window.getComputedStyle(cartBtn).position !== "fixed") {
      const submitBtn = cartBtn.querySelector(".product__submit__item .btn--submit");
      if (submitBtn && window.getComputedStyle(submitBtn).position === "fixed") {
        fixedEl = submitBtn;
      }
    }
    document.body.style.paddingBottom = fixedEl.offsetHeight + "px";
    document.body.classList.add("has-sticky-cart");
    document.documentElement.style.setProperty("--sticky-bar-height", fixedEl.offsetHeight + "px");
  }

  // Mini product card in the sticky bar (image + price + the real variant
  // picker + Add to Cart, no Buy Now). Applies to both the standard and
  // underEye-style submit-button layouts, since both now render the same markup.
  const selectorsSlot = cartBtn.querySelector("[data-sticky-cart-selectors]");
  const productSelectors = document.querySelector(".product__selectors");
  let selectorsHome = null;
  if (productSelectors) {
    selectorsHome = { parent: productSelectors.parentNode, next: productSelectors.nextSibling };
  }

  function moveSelectorsIntoStickyBar() {
    if (!productSelectors || !selectorsSlot) return;
    selectorsSlot.appendChild(productSelectors);
    selectorsSlot.style.display = "flex";
  }

  function moveSelectorsHome() {
    if (!productSelectors || !selectorsHome) return;
    if (productSelectors.parentNode === selectorsSlot) {
      if (selectorsHome.next) {
        selectorsHome.parent.insertBefore(productSelectors, selectorsHome.next);
      } else {
        selectorsHome.parent.appendChild(productSelectors);
      }
    }
    if (selectorsSlot) selectorsSlot.style.display = "none";
  }

  // Picking a variant can legitimately scroll the page (the theme scrolls
  // tall/stacked image layouts to the matching image on variant change, via
  // scrollTo/scroll/scrollIntoView calls - some fired through a `setTimeout`,
  // so the jump can land well after the click) - but that reads as a jarring
  // jump away from wherever the user is reading, whether the picker is in
  // its normal in-page spot or relocated into the bottom sticky bar.
  // Suppress all forms of programmatic scroll for a window after any click
  // on the picker so that jump never happens in the first place, rather
  // than reacting to it after the fact (which fights any in-progress
  // smooth-scroll animation and shows up as visible bouncing). `productSelectors`
  // is the same node in both locations (moved, not cloned), so one listener
  // on it covers both.
  if (productSelectors) {
    var originalWindowScrollTo = window.scrollTo;
    var originalWindowScroll = window.scroll;
    var originalScrollIntoView = Element.prototype.scrollIntoView;
    var restoreScrollTimer = null;

    productSelectors.addEventListener(
      "click",
      function () {
        if (restoreScrollTimer) {
          clearTimeout(restoreScrollTimer);
        } else {
          window.scrollTo = function () {};
          window.scroll = function () {};
          Element.prototype.scrollIntoView = function () {};
        }
        restoreScrollTimer = setTimeout(function () {
          window.scrollTo = originalWindowScrollTo;
          window.scroll = originalWindowScroll;
          Element.prototype.scrollIntoView = originalScrollIntoView;
          restoreScrollTimer = null;
        }, 1200);
      },
      true
    );
  }

  const forceSticky = cartBtn.hasAttribute("data-force-sticky");

  function toggleSticky() {
    const sticky = forceSticky || !isInViewport(placeholder);
    cartBtn.classList.toggle("sticky-cart", sticky);
    reserveStickySpace();

    if (sticky) {
      moveSelectorsIntoStickyBar();
    } else {
      moveSelectorsHome();
    }
  }

  window.addEventListener("scroll", toggleSticky);
  window.addEventListener("resize", toggleSticky);
  toggleSticky();

  // Mirror the current variant's price into the sticky bar - the theme already
  // recomputes the main price DOM before this event fires, so just copy it
  // rather than re-implementing money formatting.
  document.addEventListener("theme:variant:change", function (evt) {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    const stickyImage = document.querySelector("[data-sticky-cart-image]");
    if (stickyImage && variant.featured_media) {
      // The main gallery already renders one slide per media item, tagged
      // with the real media id and a server-rendered src/srcset/alt - reuse
      // that instead of re-deriving a CDN URL ourselves, so the sticky image
      // always matches whatever the main PDP is actually showing.
      const gallerySlideImage = document.querySelector(
        '[data-product-slide][data-id="' + variant.featured_media.id + '"] img'
      );
      if (gallerySlideImage) {
        stickyImage.src = gallerySlideImage.currentSrc || gallerySlideImage.src;
        if (gallerySlideImage.srcset) {
          stickyImage.srcset = gallerySlideImage.srcset;
        } else {
          stickyImage.removeAttribute("srcset");
        }
        stickyImage.alt = gallerySlideImage.alt || "";
      } else if (variant.featured_media.preview_image) {
        const src = variant.featured_media.preview_image.src;
        stickyImage.src = src + (src.indexOf("?") === -1 ? "?" : "&") + "width=120";
        stickyImage.removeAttribute("srcset");
      }
    }

    const stickyPrice = document.querySelector("[data-sticky-cart-price]");
    if (stickyPrice) {
      const mainPrice = document.querySelector(".product__price[data-price-wrapper] [data-product-price]");
      if (mainPrice) {
        // Real PDP layouts have this element (e.g. via a reviews-app block
        // that renders it) and keep it live on variant change - just copy it.
        stickyPrice.innerHTML = mainPrice.innerHTML;
      } else if (variant.price === 0) {
        stickyPrice.textContent = (window.theme && window.theme.strings && window.theme.strings.free) || stickyPrice.textContent;
      } else if (window.theme && window.theme.moneyFormat) {
        // No such element here (e.g. this "Featured product" instance has no
        // reviews-app price block) - compute the price ourselves straight
        // from the variant instead of depending on another element existing.
        const useCurrencyCode = !!(window.theme.settings && window.theme.settings.currency_code_enable);
        const format = useCurrencyCode ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
        const placeholderMatch = format && format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (placeholderMatch) {
          const amount = (variant.price / 100).toFixed(2);
          const amountParts = amount.split(".");
          const grouped = amountParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          // Mirrors the theme's own money_without_trailing_zeros look (used
          // by this same element's initial, server-rendered price) for the
          // plain, non currency-code format - drop ".00" for whole prices.
          const dropDecimals = placeholderMatch[1] === "amount_no_decimals" || (!useCurrencyCode && amountParts[1] === "00");
          const value = dropDecimals ? grouped : grouped + "." + amountParts[1];
          stickyPrice.textContent = format.replace(placeholderMatch[0], value);
        }
      }
    }

    // The sticky bar's own height can change with the new variant (e.g. price
    // text wrapping differently, a sold-out state appearing), which desyncs
    // it from the body's reserved bottom padding and reads as the page
    // jumping slightly the moment a variant is picked. Recompute once the
    // DOM settles instead of waiting for the next scroll/resize event.
    setTimeout(reserveStickySpace, 50);
  });

  // Compact "pill" that shows the current variant and expands the real
  // picker (moved in above) as a small dropdown on tap, instead of showing
  // every option inline - keeps the bar short and gives every product the
  // same look regardless of variant count. Single-variant products get the
  // same pill styling but as a plain, non-interactive label - there's
  // nothing to pick, so it doesn't open a dropdown.
  if (selectorsSlot) {
    const variantCount = parseInt(selectorsSlot.getAttribute("data-variant-count"), 10) || 1;
    selectorsSlot.classList.add("sticky-cart__selectors--collapsed");
    const pill = document.createElement(variantCount > 1 ? "button" : "span");
    if (variantCount > 1) {
      pill.type = "button";
      pill.setAttribute("aria-expanded", "false");
    }
    pill.className = "sticky-cart__variant-pill";
    if (variantCount <= 1) pill.classList.add("sticky-cart__variant-pill--single");
    const pillLabel = document.createElement("span");
    pillLabel.className = "sticky-cart__variant-pill-label";
    pillLabel.textContent = selectorsSlot.getAttribute("data-initial-variant-label") || "";
    pill.appendChild(pillLabel);
    selectorsSlot.insertBefore(pill, selectorsSlot.firstChild);

    if (variantCount > 1) {
      const closePill = () => {
        selectorsSlot.classList.remove("is-open");
        pill.setAttribute("aria-expanded", "false");
      };

      pill.addEventListener("click", function (e) {
        e.stopPropagation();
        const isOpen = selectorsSlot.classList.toggle("is-open");
        pill.setAttribute("aria-expanded", String(isOpen));
      });

      document.addEventListener("click", function (e) {
        if (!selectorsSlot.classList.contains("is-open")) return;
        if (!selectorsSlot.contains(e.target)) closePill();
      });
    }

    document.addEventListener("theme:variant:change", function (evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      pillLabel.textContent = variant.title;
      if (variantCount > 1) {
        selectorsSlot.classList.remove("is-open");
        pill.setAttribute("aria-expanded", "false");
      }
    });
  }
});

// Filter product gallery images by variant alt-text tags
(function () {
  var _skipActive = false;
  var _skipSetup = false;

  // Strip spaces, hyphens, underscores, parentheses etc. so
  // "50mg (15 Capsules)" and "50mg-15capsules" both become "50mg15capsules".
  function normalizeAlt(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function getSelectedOptions() {
    var options = [];
    document.querySelectorAll('input[data-single-option-selector][type="radio"]:checked').forEach(function (input) {
      if (input.value) options.push(normalizeAlt(input.value));
    });
    document.querySelectorAll('input[data-single-option-selector][type="hidden"]').forEach(function (input) {
      if (input.value) options.push(normalizeAlt(input.value));
    });
    return options;
  }

  // Which variant-option tokens actually apply to this alt text — as plain
  // substring search, a bundle option like "buy2100mlandget110mlfree" also
  // matches the shorter "100ml"/"10ml" options embedded inside it, so an
  // image tagged for the bundle variant would incorrectly show for those
  // plain size variants too. Keep only the "maximal" matches: drop any match
  // that is itself a substring of a longer match found in the SAME alt, so
  // the most specific (longest) option wins and the embedded shorter ones
  // are suppressed.
  function getMatchingOptions(alt, allOptions) {
    var matches = allOptions.filter(function (o) { return o && alt.indexOf(o) !== -1; });
    return matches.filter(function (o) {
      return !matches.some(function (other) { return other !== o && other.indexOf(o) !== -1; });
    });
  }

  // Set up a one-time Flickity change handler that skips over hidden slides
  function setupSkipHandler(flkty, slides) {
    if (_skipSetup) return;
    _skipSetup = true;

    var lastIndex = flkty.selectedIndex;

    flkty.on('change', function () {
      if (_skipActive) return;
      var idx = flkty.selectedIndex;
      var current = slides[idx];
      if (current && current.style.display === 'none') {
        var total = slides.length;
        // Keep skipping in the same direction the user was navigating
        // (e.g. Previous should never bounce forward to find a visible slide).
        var goingBackward = idx === (lastIndex - 1 + total) % total;
        var step = goingBackward ? -1 : 1;
        _skipActive = true;
        for (var i = 1; i <= total; i++) {
          var next = ((idx + step * i) % total + total) % total;
          if (slides[next] && slides[next].style.display !== 'none') {
            // Animate the redirect (isInstant=false) so it reads as a slide,
            // not a snap, when the user swipes/clicks past a hidden variant image.
            flkty.select(next, false, false);
            break;
          }
        }
        _skipActive = false;
      }
      lastIndex = flkty.selectedIndex;
    });
  }


  function filterGallery() {
    var container = document.querySelector('[data-product]') || document;
    var allSlides = Array.from(container.querySelectorAll('.product-single__media-slide[data-id]'));
    var thumbs = Array.from(container.querySelectorAll('.product-single__thumbnail[data-id]'));
    if (!allSlides.length) return;

    var optionValues = getSelectedOptions();
    if (!optionValues.length) return;

    var altMap = {};
    allSlides.forEach(function (slide) {
      altMap[slide.dataset.id] = normalizeAlt(slide.dataset.alt);
    });
    thumbs.forEach(function (thumb) {
      var id = thumb.dataset.id;
      if (!altMap[id]) {
        altMap[id] = normalizeAlt(thumb.dataset.alt);
      }
    });

    var allVariantOptions = [];
    if (window.product && window.product.variants) {
      window.product.variants.forEach(function (v) {
        (v.options || []).forEach(function (o) {
          allVariantOptions.push(normalizeAlt(o));
        });
      });
    }

    var isFilteringProduct = Object.values(altMap).some(function (alt) {
      return alt && getMatchingOptions(alt, allVariantOptions).length > 0;
    });

    console.log('[chosenFilter] optionValues:', optionValues, '| isFiltering:', isFilteringProduct);

    if (!isFilteringProduct) return;

    var firstVisibleIndex = -1;

    allSlides.forEach(function (slide, i) {
      var alt = altMap[slide.dataset.id] || '';
      var matchedOptions = getMatchingOptions(alt, allVariantOptions);
      var isVariantAlt = matchedOptions.length > 0;
      var show = !isVariantAlt || optionValues.some(function (o) { return matchedOptions.indexOf(o) !== -1; });
      slide.style.display = show ? '' : 'none';

      // Keep Fancybox gallery in sync: remove hidden slides from the gallery group
      var fbLink = slide.querySelector('[data-fancybox]') || slide.querySelector('[data-fancybox-orig]');
      if (fbLink) {
        if (show) {
          var orig = fbLink.getAttribute('data-fancybox-orig');
          if (orig) {
            fbLink.setAttribute('data-fancybox', orig);
            fbLink.removeAttribute('data-fancybox-orig');
          }
        } else {
          var cur = fbLink.getAttribute('data-fancybox');
          if (cur) {
            fbLink.setAttribute('data-fancybox-orig', cur);
            fbLink.removeAttribute('data-fancybox');
          }
        }
      }

      if (show && firstVisibleIndex === -1) firstVisibleIndex = i;
    });

    thumbs.forEach(function (thumb) {
      var alt = altMap[thumb.dataset.id] || '';
      var matchedOptions = getMatchingOptions(alt, allVariantOptions);
      var isVariantAlt = matchedOptions.length > 0;
      var show = !isVariantAlt || optionValues.some(function (o) { return matchedOptions.indexOf(o) !== -1; });
      thumb.style.display = show ? '' : 'none';
    });

    // Get Flickity instance via themeVendor if not stored
    var slider = container.querySelector('[data-product-single-media-slider]');
    var flkty = window._chosenFlkty;
    if (!flkty && window.themeVendor && window.themeVendor.Flickity && slider) {
      flkty = window.themeVendor.Flickity.data(slider);
    }

    if (flkty) {
      // Wire up skip-hidden navigation once
      setupSkipHandler(flkty, allSlides);
      // reloadCells() forces Flickity to re-measure hidden cells as 0-width,
      // eliminating blank gaps. Must come BEFORE select().
      flkty.reloadCells();
      if (firstVisibleIndex >= 0) {
        flkty.select(firstVisibleIndex, false, true);
      }

      // Sync page dots — run via both Flickity's internal dots array and DOM,
      // deferred 100ms so any async Flickity redraws finish first
      var slidesSnap = allSlides;
      var sliderSnap = slider;
      var flktySnap = flkty;
      function syncDots() {
        // Prefer internal reference; fall back to DOM query
        var dotEls = (flktySnap.pageDots && flktySnap.pageDots.dots)
          ? flktySnap.pageDots.dots
          : sliderSnap ? Array.from(sliderSnap.querySelectorAll('.flickity-page-dot')) : [];
        slidesSnap.forEach(function (slide, i) {
          if (dotEls[i]) {
            dotEls[i].style.display = slide.style.display === 'none' ? 'none' : '';
          }
        });
      }
      syncDots();
      setTimeout(syncDots, 100);
    }

    // Also reload thumbnail Flickity so it removes gaps from hidden thumbs
    if (window.themeVendor && window.themeVendor.Flickity) {
      var thumbsEl = container.querySelector('.product-single__thumbnails');
      if (thumbsEl) {
        var flktyNav = window.themeVendor.Flickity.data(thumbsEl);
        if (flktyNav) {
          flktyNav.reloadCells();
        }
      }
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-single-option-selector]')) return;
    setTimeout(filterGallery, 150);
  });

  document.addEventListener('theme:variant:change', function () {
    setTimeout(filterGallery, 150);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(filterGallery, 500);
  });
})();

// Move sold-out products to the end of the collection grid
(function () {
  function moveSoldOutToLast() {
    const grid = document.querySelector('[data-collection-products] .grid');
    if (!grid) return;
    const soldOut = [...grid.querySelectorAll('.product-grid-item.soldout')];
    if (soldOut.length === 0) return;
    soldOut.forEach(item => grid.appendChild(item));
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', moveSoldOutToLast);

  // Re-run after infinite scroll loads more products
  document.addEventListener('DOMContentLoaded', function () {
    const loop = document.querySelector('#AjaxinateLoop');
    if (!loop) return;
    const observer = new MutationObserver(function () {
      clearTimeout(window._soldOutTimer);
      window._soldOutTimer = setTimeout(moveSoldOutToLast, 150);
    });
    observer.observe(loop, { childList: true });
  });
})();

// Click-to-copy coupon code icon in the announcement bar (see snippets/announcement.liquid coupon_code_button)
(function () {
  function copyTextLegacy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    // The Clipboard API is blocked inside cross-origin iframes without an
    // explicit "clipboard-write" permission - e.g. the Shopify theme editor's
    // preview iframe - so always fall back to the legacy execCommand method
    // when it's unavailable or rejects, rather than failing silently.
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        copyTextLegacy(text);
      });
    }
    copyTextLegacy(text);
    return Promise.resolve();
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    const code = btn.getAttribute('data-copy-code');
    copyText(code).then(function () {
      btn.classList.add('is-copied');
      clearTimeout(btn._copyTimer);
      btn._copyTimer = setTimeout(function () {
        btn.classList.remove('is-copied');
      }, 1200);
    });
  });
})();







